import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

function Header({ isAdmin }) {
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  
  return (
    <header className="app-header">
      <div className="header-inner">
        <div className="logo-container">
          <Link to="/" className="logo-link">
            <h1>LaserBay</h1>
          </Link>
        </div>
        <nav className="main-nav">
          <Link to="/" className="nav-link">Calendrier</Link>
          <Link to={`/daily/${todayStr}`} className="nav-link">Aujourd'hui</Link>
          {isAdmin && (
            <>
              <Link to="/planning" className="nav-link">Planning</Link>
              <Link to="/tournois" className="nav-link">Tournois</Link>
              <Link to="/admin/dashboard" className="nav-link admin-link">Dashboard</Link>
            </>
          )}
          {!isAdmin && (
            <Link to="/admin" className="nav-link admin-lock" title="Administration">🔒</Link>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
